import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Hero from './components/Hero';
import Viajes from './components/Viajes';
import Destinos from './components/Destinos';            // default export desde Destinos.jsx
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import Nosotros from './components/Nosotros';
import Testimonios from './components/Testimonios';
import BotonVideollamadaFlotante from './components/BotonVideollamadaFlotante';
import useScrollToHash from './hooks/useScrollToHash';
import SEOHead from './components/SEOHead';
import { organizationSchema, websiteSchema } from './data/structuredData';
import PageTransition from './components/PageTransition';
import SkeletonLoader from './components/SkeletonLoader';
import { useRoutePreloader } from './hooks/useRoutePreloader';
import ErrorBoundary from './components/ErrorBoundary';
import PageLoader from './components/PageLoader';
import usePageLoader from './hooks/usePageLoader';

// Lazy components con Suspense
const DestinosFiltrables = React.lazy(() => import('./components/DestinosFiltrables'));
const DetalleDestino = React.lazy(() => import('./components/DetalleDestino'));
const CrucerosPage = React.lazy(() => import('./pages/CrucerosPage'));
const AsistenciaPage = React.lazy(() => import('./pages/AsistenciaPage'));
const TerminosCondicionesPage = React.lazy(() => import('./pages/TerminosCondicionesPage'));
export default function AppRoutes() {
  useScrollToHash(); // ✅ ahora sí dentro de <Router>
  useRoutePreloader(); // Precargar rutas críticas
  const { isLoading } = usePageLoader(); // Hook para manejar el loader

  return (
    <ErrorBoundary>
      <div className="min-h-screen flex flex-col justify-between">
        {isLoading && <PageLoader />}
        <SEOHead
          title="Inicio"
          description="Planificá tus vacaciones con Belu Tours. Asesoramiento personalizado, destinos nacionales e internacionales, y experiencias únicas."
          keywords="viajes, turismo, agencia de viajes, destinos, vacaciones, Argentina, Mendoza"
          structuredData={[organizationSchema, websiteSchema]}
        />
        <Header />
        <Routes>
        <Route
          path="/"
          element={
            <PageTransition>
              <Hero />
              <Viajes />
              <Nosotros />
              <Destinos />        {/* Carrusel de destinos populares */}
              <Contacto />
              <Testimonios />
            </PageTransition>
          }
        />
        <Route 
          path="/cruceros" 
          element={
            <Suspense fallback={<SkeletonLoader type="cruise" />}>
              <PageTransition>
                <CrucerosPage />
              </PageTransition>
            </Suspense>
          } 
        />
        <Route 
          path="/destinos" 
          element={
            <Suspense fallback={<SkeletonLoader type="destination" />}>
              <PageTransition>
                <DestinosFiltrables />
              </PageTransition>
            </Suspense>
          } 
        />
        <Route 
          path="/destinos/:slug" 
          element={
            <Suspense fallback={<SkeletonLoader type="destination" />}>
              <PageTransition>
                <DetalleDestino />
              </PageTransition>
            </Suspense>
          } 
        />
        <Route 
          path="/asistencia" 
          element={
            <Suspense fallback={<SkeletonLoader type="assistance" />}>
              <PageTransition>
                <AsistenciaPage />
              </PageTransition>
            </Suspense>
          } 
        />
        <Route 
          path="/terminos-condiciones" 
          element={
            <Suspense fallback={<SkeletonLoader type="page" />}>
              <PageTransition>
                <TerminosCondicionesPage />
              </PageTransition>
            </Suspense>
          } 
        />
        </Routes>
        <Footer />
        <BotonVideollamadaFlotante />
      </div>
    </ErrorBoundary>
  );
}
